module.exports = __webpack_public_path__ + "static/img/font-12.76d730b3.svg";